<template>
	<div class="card-navigation">
		<div class="nav-buttons">
			<v-btn
				fab
				depressed
				small
				color="info"
				class="arrow-container nav-button-left custom-button-fab"
				@click="$emit('onPrevClick')"
				v-show="!disablePrevButton"
			>
				<v-icon dark size="40">keyboard_arrow_left</v-icon>
			</v-btn>
			<v-btn
				fab
				depressed
				small
				color="info"
				class="arrow-container nav-button-right custom-button-fab"
				@click="$emit('onNextClick')"
				v-show="!disableNextButton"
			>
				<v-icon dark size="40">keyboard_arrow_right</v-icon>
			</v-btn>
		</div>
		<div class="card-navigation-content" :class="{bordered}">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CardNavigation',
	props: {
		disablePrevButton: {
			type: Boolean,
			default: false,
		},
		disableNextButton: {
			type: Boolean,
			default: false,
		},
		bordered: {
			type: Boolean,
			default: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.card-navigation {
	position: relative;

	.card-navigation-content {
		&.bordered {
			border: 1px solid var(--app-color-gray);
			border-radius: 5px;
		}
		background-color: white;
	}
	.nav-buttons {
		.nav-button-right, .nav-button-left {
			position: absolute;
			margin: 0;
			top: calc(50% - 20px);
		}
		.nav-button-left {
			left: -20px;
		}
		.nav-button-right {
			right: -20px;
		}
	}
}

</style>



// WEBPACK FOOTER //
// src/modules/shared/components/ui/CardNavigation.vue